export {
  Stepper,
  type StepperProps,
} from '@tui-cruises/mein-schiff-web-react-component-library/src/components/core/Stepper';
